module.exports = __webpack_public_path__ + "bfe2ba30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon_steps2_activated@2x.png
// module id = 1159
// module chunks = 0